export enum PickupOption {
	TO_GO 	 = "TO_GO",
	FOR_HERE = "FOR_HERE",
	DELIVERY = "DELIVERY",
	DRIVE_IN = "DRIVE_IN"
}



// WEBPACK FOOTER //
// ./src/app/pages/orders/enums/pickup-option.enum.ts